// extracted by mini-css-extract-plugin
module.exports = {"panel":"Team_panel__12m4J","tooltip":"Team_tooltip__2eo7B","block1":"Team_block1__1GurO"};